import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../api/axiosInstance";

// Fetch Camera List
export const fetchCameraList = createAsyncThunk(
  "camera/fetchCameraList",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axios.request({
        url: "VMS_API_USER_GETCAMERALIST",
        method: "POST",
        data: { UserID: userId },
      });
      return response.data.CameraInfo;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong");
    }
  }
);

// Add Camera
export const addCamera = createAsyncThunk(
  "camera/addCamera",
  async (cameraData, { rejectWithValue }) => {
    try {
      const response = await axios.post("VMS_API_ADD_CAMERA", cameraData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong");
    }
  }
);

// Delete Camera
export const deleteCamera = createAsyncThunk(
  "camera/deleteCamera",
  async ({ userId, cameraStream }, { rejectWithValue }) => {
    try {
      const response = await axios.post("VMS_API_DELETE_CAMERA", {
        UserID: userId,
        Camera_Stream: cameraStream,
      });
      return { cameraStream, response: response.data };
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong");
    }
  }
);

// Test Camera Connection
export const testCameraConnection = createAsyncThunk(
  "camera/testCameraConnection",
  async (cameraData, { rejectWithValue }) => {
    try {
      const response = await axios.post("VMS_API_TEST_CAMERA", cameraData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong");
    }
  }
);

const cameraSlice = createSlice({
  name: "camera",
  initialState: {
    cameras: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCameraList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCameraList.fulfilled, (state, action) => {
        state.cameras = action.payload;
        state.loading = false;
      })
      .addCase(fetchCameraList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Camera
      .addCase(addCamera.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addCamera.fulfilled, (state) => {
        state.loading = false;
        // Optional: could fetch camera list again here
      })
      .addCase(addCamera.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delete Camera
      .addCase(deleteCamera.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCamera.fulfilled, (state, action) => {
        state.loading = false;
        const deletedStream = action.payload.cameraStream;
        state.cameras = state.cameras.filter(
          (camera) => camera.Camera_Stream !== deletedStream
        );
      })
      .addCase(deleteCamera.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Test Camera Connection
      .addCase(testCameraConnection.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(testCameraConnection.fulfilled, (state, action) => {
        state.loading = false;
        // You can handle success response here if needed
        // e.g., state.connectionTestResult = action.payload;
      })
      .addCase(testCameraConnection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default cameraSlice.reducer;
